import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Anchor, Body, Card } from '@sumup-oss/circuit-ui';

import { StyledComponentsParams } from 'types/components';

export const ArticleDescription = styled(Body)(
  ({ theme }: StyledComponentsParams) => css`
    margin-bottom: ${theme.spacings.mega};
    overflow: hidden;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `,
);

export const ReadArticleLink = styled(Anchor)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--cui-fg-accent);

  svg {
    margin-bottom: -2px;
    transform: translateX(0);
    transition: transform 0.18s ease-in-out;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;

export const SectionArticlesItem = styled(Card)(
  ({ theme }: StyledComponentsParams) => css`
    ${theme.mq.untilMega} {
      margin-bottom: ${theme.spacings.mega};
    }
    ${theme.mq.mega} {
      margin-bottom: ${theme.spacings.giga};
    }
  `,
);
